import React from 'react';
import Notice from '../components/wiki/Notice/Notice';

const NoticePage = () => {
  return <Notice />;
};

export default NoticePage;
